import React from "react"
import SlateNode from "../slate-node"
import { useInheritedTheme } from "../../hooks/use-theme"
import typographyStyles from "../../utils/typography-styles"
import borderStyles from "./border-styles"

function Blockquote({ attributes, children, node, serializingFind }) {
  const { find: editingFind } = useInheritedTheme()
  const find = serializingFind || editingFind

  return (
    <SlateNode
      node={node}
      style={{
        ...typographyStyles("blockquote", find),
        padding: "10px 20px",
        margin: "0 0 20px",
        ...borderStyles(find)
      }}
      className="blockquotes"
      {...attributes}
    >
      {children}
    </SlateNode>
  )
}

function BlockquoteLine({ attributes, children }) {
  return (
    <div className="blockquotes-line" {...attributes}>
      {children}
    </div>
  )
}
export default {
  component: Blockquote,
  commands: {
    wrapBlockquote: editor => {
      const rootBlocks = editor.value.document.getRootBlocksAtRange(
        editor.value.selection
      )
      editor.withoutNormalizing(() => {
        if (rootBlocks.size === 1) {
          editor.wrapBlockByKey(editor.value.startBlock.key, "blockquote")
          return
        }
        rootBlocks.forEach(block => {
          editor.wrapBlockByKey(block.key, "blockquote-line")
        })
        editor.wrapBlock("blockquote")
      })
    },

    unwrapBlockquote: editor => {
      const startBlock = editor.value.startBlock
      if (startBlock.type === "blockquote-line") {
        const parent = editor.value.document.getParent(startBlock.key)
        editor.withoutNormalizing(() => {
          editor.unwrapBlockByKey(parent.key, { type: "blockquote" })
          parent.nodes.forEach(block => {
            editor.setNodeByKey(block.key, { type: "paragraph" })
          })
        })
      }
    },

    toggleBlockquote: editor => {
      const block = editor.value.startBlock
      if (block.type == "blockquote-line") {
        editor.unwrapBlockquote()
      } else {
        editor.wrapBlockquote()
      }
    }
  },
  schema: {
    nodes: [
      {
        match: { type: "blockquote-line" },
        min: 1
      }
    ],
    normalize: (editor, error) => {
      switch (error.code) {
        case "child_min_invalid":
          editor.insertNodeByKey(error.node.key, 0, {
            object: "block",
            type: "blockquote-line"
          })
          return
        case "child_type_invalid":
          editor.wrapBlockByKey(error.child.key, {
            type: "blockquote-line"
          })
          return
        default:
          return
      }
    }
  },
  nodes: {
    "blockquote-line": {
      component: BlockquoteLine,
      schema: {
        nodes: [
          {
            match: [{ object: "text" }, { object: "inline" }]
          }
        ],
        normalize: (editor, error) => {
          switch (error.code) {
            case "child_object_invalid": {
              editor.withoutNormalizing(() => {
                error.child.nodes.forEach((node, index) => {
                  editor.moveNodeByKey(node.key, error.node.key, index)
                })
                editor.removeNodeByKey(error.child.key)
              })
              return
            }
            default:
              return
          }
        }
      },
      keymap: {
        enter: (event, editor, next) => {
          const { selection, startBlock } = editor.value
          if (selection.start.offset === 0 && startBlock.getText() === "") {
            event.preventDefault()
            if (selection.isExpanded) editor.delete()

            const document = editor.value.document
            const blockquote = editor.value.document.getParent(startBlock.key)
            const index = document.nodes.indexOf(blockquote)

            editor.withoutNormalizing(() => {
              editor.setBlocks("paragraph")
              editor.moveNodeByKey(startBlock.key, document.key, index + 1)
            })

            return
          }
          return next()
        },
        backspace: (event, editor, next) => {
          const { selection, startBlock } = editor.value
          if (selection.isExpanded) return next()
          if (selection.start.offset !== 0) return next()
          const parent = editor.value.document.getParent(startBlock.key)
          if (parent.nodes.first().key !== startBlock.key) return next()
          event.preventDefault()
          editor.unwrapBlockquote()
        }
      }
    }
  }
}
